module.exports = __webpack_public_path__ + "img/img-user.5de14a58.svg";